import { render, staticRenderFns } from "./BranchDetails.vue?vue&type=template&id=2c85752d&scoped=true&"
import script from "./BranchDetails.vue?vue&type=script&lang=js&"
export * from "./BranchDetails.vue?vue&type=script&lang=js&"
import style0 from "./BranchDetails.vue?vue&type=style&index=0&id=2c85752d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c85752d",
  null
  
)

export default component.exports